import { useState } from "react";
import { useLocation } from "react-router-dom";
import { Attachment, Health, SocialData, StudentBioData } from "../../../StudentMgt";
import { TabContainer, TabContent, TabLink, TabLinkContainer } from "../../../../pages/Dashboard/styles/dashboard.style";

const AdmissionForm = ({data}) => {
  const [formLoading, setFormLoading] = useState(false);
  const location = useLocation();
  const schoolId = new URLSearchParams(location.search).get("school_id") || "1";
  const [tab, setTab] = useState(1);

  const [bioObj, setBioObj] = useState(data?.bioData || {
    studentId: 0,
    schoolName: "",
    admissionId: 0,
    phoneNumber: "",
    email: "",
    profileImagePath: "",
    schoolId: schoolId,
    firstName: "",
    lastName: "",
    otherName: "",
    admission_no: "",
    residentialeAddress: "",
    origin: "",
    studentAge: 0,
    classId: 0,
    gender: "",
    dateOfBirth: "",
    height: "",
    weight: "",
    hometown: "",
    nationality: "",
    localGovernment: "",
    nearestBustop: "",
    religion: "",
    parentPhoneNumber: "",
    parentEmail: "",
    childOrWardWorshipRole: "",
    vicorOrPastorName: "",
    vicorOrPastorPhoneNo: "",
    eyeColor: "",
    denomination: "",
    denominationAddress: "",
    accountStatus: "",
    createdBy: "",
    placeofBirth: "",
    nameOfChurch: "",
    className: "",
    parentId: 0
  });

  const [socialObj, setSocialObj] = useState(data?.socialData || {
    studentId: 0,
    schoolId: schoolId,
    childPosition_In_Family: "",
    childPosition_On_Mother: "",
    childAmbition: "",
    childEasyThings: "",
    isChildBedWet: true,
    note_On_Child: "",
    isChild_Away_FromHome_Before: true,
    parentPhoneNumber: "",
  });

  const [healthObj, setHealthObj] = useState(data?.healthData || {
    schoolId: Number(schoolId),
    studentId: 0,
    isSickleCell: false,
    hasEyeDisease: false,
    hasEpilespy: false,
    hasEarDisease: false,
    hasDiabetics: false,
    hasNoseDisease: false,
    hasTuberculosis: false,
    hasRespiratoryDisease: false,
    hasHeartDisease: false,
    hasKidneyDisease: false,
    hasMentalOrNervousDisease: false,
    hasAlergies: false,
    hasDigestiveDisease: false,
    isChild_HandCap: false,
    isChildAdmitted_To_Hospital: false,
    isChildOperatedBefore: false,
    operationDetails: "",
    isChildOnMedication: false,
    familyAilment: "",
    ailmentStatus: "",
    bloodGroup: "",
    medicalAdvise: "",
    genotype: "",
    childAilment: "",
    childAllergicReaction: "",
    bcgStatus: "",
    bcgDate: "2023-05-15T13:48:50.100Z",
    dptStatus: "",
    dptDate: "2023-05-15T13:48:50.100Z",
    oralPolioStatus: "",
    oralPolioDate: "2023-05-15T13:48:50.100Z",
    yellowFeverStatus: "",
    yellowFeverDate: "2023-05-15T13:48:50.100Z",
    parentPhoneNumber: "",
    parentSignatureDate: "",
  });

  const [attachments, setAttachments] = useState(data?.attachmentData || []);
  const [attachObj, setAttachObj] = useState(attachments[0] || {
    admissionId: 0,
    schoolId: Number(schoolId),
    fileName: "",
    fileContentPath: "",
    fileContent: "",
  });
  
  return (
    <>
      {" "}
      <>
        <TabContainer>
          <TabLinkContainer>
            <TabLink isActive={tab === 1} onClick={() => setTab(1)}>
              <p>Student Bio-data</p>
            </TabLink>
            <TabLink isActive={tab === 2} onClick={() => setTab(2)}>
              <p>Social Data</p>
            </TabLink>
            <TabLink isActive={tab === 3} onClick={() => setTab(3)}>
              <p>Health Data</p>
            </TabLink>
            <TabLink isActive={tab === 4} onClick={() => setTab(4)}>
              <p>Attachments</p>
            </TabLink>
          </TabLinkContainer>

          <TabContent>
            {tab === 1 && (
              <StudentBioData
                bioData={bioObj}
                setBioData={setBioObj}
                readOnly={true}
                loading={formLoading}
                showInfoButton={false}
              />
            )}
            {tab === 2 && (
              <SocialData
                bioData={socialObj}
                setBioData={setSocialObj}
                readOnly={true}
                loading={formLoading}
                showInfoButton={false}
              />
            )}
            {tab === 3 && (
              <Health
                bioData={healthObj}
                setBioData={setHealthObj}
                loading={formLoading}
                readOnly={true}
                showInfoButton={false}
              />
            )}
            {tab === 4 && (
              <Attachment
                showForm={true}
                data={attachments}
                loading={formLoading}
                obj={attachObj}
                setObj={setAttachObj}
                readOnly={true}
              />
            )}
          </TabContent>
        </TabContainer>
      </>
    </>
  );
};

export default AdmissionForm;
